
const brokerEtfsTags = (eventTag) => (
    {
        comercialCardsLink: {
            categoriaEvento: 'etfHomeInteraction',
            accionEvento: 'ComercialCard',
            etiquetaEvento: 'more-info'
        },
        buyButtonComCard: {
            categoriaEvento: 'etfsHomeInteraction',
            accionEvento: 'comercialCard',
            etiquetaEvento: 'buy'
        },
        searchButton: {
            categoriaEvento: 'buscador/simple',
            accionEvento: 'inicio',
            etiquetaEvento: 'etfs'
        },
        buyButton: {
            categoriaEvento: 'etfHomeInteraction',
            accionEvento: 'buy',
            etiquetaEvento: 'etfs'
        },
        sliderProducts: {
            categoriaEvento: 'etfHomeInteraction',
            accionEvento: 'sliderMenu',
            etiquetaEvento: 'products'
        },
        sliderContracts: {
            categoriaEvento: 'etfHomeInteraction',
            accionEvento: 'sliderMenu',
            etiquetaEvento: 'contracts'
        },
        searchButtonOnProduct: {
            categoriaEvento: 'etfDescriptionInteraction',
            accionEvento: 'searcher',
            etiquetaEvento: 'click'
        },
        openTraderButton: {
            categoriaEvento: 'etfDescriptionInteraction',
            accionEvento: 'opentrader',
            etiquetaEvento: 'click'
        },
        buttonBuy: {
            categoriaEvento: 'etfDescriptionInteraction',
            accionEvento: 'buy',
            etiquetaEvento: eventTag
        },
        tabs: {
            categoriaEvento: 'etfDescriptionInteraction',
            accionEvento: 'evolution',
            etiquetaEvento: eventTag
        },
        documentation: {
            categoriaEvento: 'etfDescriptionInteraction',
            accionEvento: 'downloads',
            etiquetaEvento: eventTag
        }
    }
)

module.exports = { brokerEtfsTags }